import { EventEmitter, EVENTS } from "../../../store/EventEmitter"
import { IMediaDeliveryConfig } from "../../../types"
import { Field } from "./Field"

export class FileField extends Field {
    eventEmitter: EventEmitter<any>
    private mediaConfig: IMediaDeliveryConfig
    constructor(name: string, value: any, mediaConfig: IMediaDeliveryConfig, onChange: (newValue: any) => void) {
      super(name, value, onChange)
      this.mediaConfig = mediaConfig
      this.eventEmitter = EventEmitter.getInstance();
    }
    
    public render(): HTMLElement {
      const container = this.createContainer();
      const fileInputContainer = document.createElement('div')
      fileInputContainer.className = 'file-input-container'
      fileInputContainer.style.width = '100px'
      fileInputContainer.style.height = '100px'
      fileInputContainer.style.border = '1px solid #ccc'
      fileInputContainer.style.backgroundSize = 'cover'
      fileInputContainer.style.cursor = 'pointer'
      fileInputContainer.style.backgroundImage = `url(${this.value})`;
      fileInputContainer.addEventListener('click', () => {
        input.click()
      })
      container.appendChild(fileInputContainer)
      
      const input = document.createElement('input')
      input.type = 'file'      
      input.accept = 'image/*';
      input.id = this.name
      input.name = this.name
      input.style.display = 'none'
      input.addEventListener('change', async (event) => {
        const target = event.target as HTMLInputElement
        if(!target || !target.files) return;
        const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
        const fileExtension = target.files[0]?.name.split('.').pop()?.toLowerCase();
        if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
          // this.snackBar.showSnackBar('error', 'Invalid file type. Please upload an image file.');
          EventEmitter.getInstance<any>().emit(EVENTS.VALIDATIONERROR,{
            message:"Invalid file format. Please upload an valid image file"
          });
          return;
        }
        if (target.files && target.files.length > 0) {
          const file = target.files[0]
          // if media config then get URl from media delivery
            if(this.mediaConfig && this.mediaConfig.getURLFromFile instanceof Function){
            let url = await this.mediaConfig.getURLFromFile(file);
            this.value = url;
            }else{
            //else store the base64 string 
            const base64String = await new Promise<string>((resolve, reject) => {
              const reader = new FileReader();
              reader.onload = () => {
              if (reader.result) {
                resolve(reader.result.toString());
              }
              };
              reader.onerror = (error) => {
              console.error('Error reading file:', error);
              reject(error);
              };
              reader.readAsDataURL(file);
            });
            
            this.value = base64String;
            }
          fileInputContainer.style.backgroundImage = `url(${this.value})`
          input.style.backgroundImage = `url(${this.value})`
          this.onChange(this.value);
        }
      })
  
      container.appendChild(input);
      (input as any)['fieldObj'] = this;
      return container
    }
  }